import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import MainImage from '../../../ReusableBlocks/MainImage';
import Carousel from '../../../ReusableBlocks/Carousel';
import Lightbox from '../../../ReusableBlocks/Lightbox';
import BackNavbar from '../../../ReusableBlocks/Navbar';
import Modal from 'react-bootstrap/Modal';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import learninghublogo from '../../../Images/Learning-hub-logo.png'
import Loading_Scren from '../../../ReusableBlocks/Loading_Screen';
import LoadingBar from '../../../Images/Animation - 1710409471189.json'
import SuccessBar from '../../../Images/Done.json'
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { postData, postBYO, resetOnSuccessIngest, postRenameService } from '../../../Redux/Dashboard/External/Demo_Catalgue/DemoIngestionAction';
import { fetchNarrativeDetails } from '../../../Redux/Dashboard/External/Demo_Catalgue/DemoCatlagueAction';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import SuccesScreen from '../../../ReusableBlocks/SuccesMessage';
import CryptoJS from 'crypto-js';
import * as PATH from '../../../CentralisedLink'
import TenantDropdown from '../../../ReusableBlocks/TenantDropdown';
import { normalizeMediaUrl } from '../../../Utils/mediaUrls';

const RightSideModal = ({ isOpen, onClose, Narrative }) => {



  const navigate = useNavigate();
  const dispatch = useDispatch();




  // NEW: tenants array from backend
  const userTenants = Array.isArray(Narrative?.['user-tenants'])
    ? Narrative['user-tenants']
    : [];




  const [noTenantsMessage, setNoTenantsMessage] = useState('');
  const [selectedTenantDetails, setSelectedTenantDetails] = useState(null);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedRadio, setSelectedRadio] = useState('');
  const [selectScenario, setSelectScenario] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);




  // Loading 
  const [loadingTitle, setLoadingTitle] = useState(`Ingesting narrativeTitle} In Progress`);
  const [loadingAnimation, setLoadingAnimation] = useState(LoadingBar);
  const [url, setUrl] = useState('');
  const [vsibilty, setVsibilty] = useState('-none');

  const [onSuccesIngestLoading, setOnSuccesIngestLoading] = useState(false);
  const [SuccessAnimation, setSuccessAnimation] = useState(SuccessBar);
  // const [SucsessTitle, setSucsessTitle] = useState('');
  // const [RedirectingUrl, setRedirectingUrl] = useState('');
  // const [SucessHandleLoading, setSucessHandleLoading] = useState();

  const isLoading = useSelector(state => state.Ingest?.loading);
  const error = useSelector(state => state.Ingest?.error);
  const OnSucces = useSelector(state => state.Ingest?.onSuccess);
  const loading = useSelector((state) => state.Ingest?.loading);




  // Normalize tenant to the "legacy" keys your existing actions likely expect
  const normalizeTenantForIngestion = (t) => ({
    // legacy naming (keep these to avoid changing postData/postBYO)
    'BHOM URL': t?.tenantUrl || '',
    'ITSM URL': t?.itsmUrl || '',
    'API Key': t?.key || '',
    'Secret Key': t?.secretKey || '',
    'Username': t?.username || '',
    'Password': t?.password || '',

    // keep raw fields too (useful for UI/guards)
    tenantUrl: t?.tenantUrl || '',
    itsmUrl: t?.itsmUrl || '',
    key: t?.key || '',
    secretKey: t?.secretKey || '',
    username: t?.username || '',
    password: t?.password || '',
    type: t?.type || '', // "user" | "shared"
  });

  // Build dropdown options (stable value even if tenantUrl repeats)
  const tenantOptionsv2 = useMemo(() => {
    return userTenants
      .filter(t => t?.tenantUrl) // must have at least tenantUrl
      .map((t, idx) => {
        const normalized = normalizeTenantForIngestion(t);
        const labelType = (t?.type || '').toLowerCase() === 'booked' ? 'Booked' : 'Personal';

        return {
          value: `${t.tenantUrl}__${t.type || 'user'}__${idx}`, // unique selection key
          label: `${t.tenantUrl} (${labelType})`,
          url: t.tenantUrl,                 // if you still use url somewhere
          details: normalized,              // what you store in selectedTenantDetails
          rawType: (t?.type || '').toLowerCase(),
        };
      });
  }, [userTenants]);

  useEffect(() => {
    if (!tenantOptionsv2.length) return;

    // If already selected and still valid, keep it
    const stillValid = tenantOptionsv2.some(o => o.value === selectedOption);
    if (stillValid) return;

    // Otherwise set first tenant as default selection
    const first = tenantOptionsv2[0];
    setSelectedOption(first.value);
    setSelectedTenantDetails(first.details);
  }, [tenantOptionsv2, selectedOption]);



  // Adapter for your custom dropdown
  const tenantDropdownOptions = useMemo(() => {
    return tenantOptionsv2.map((opt) => ({
      // IMPORTANT: TenantDropdown uses tenantUrl as the "value"
      tenantUrl: opt.value,          // unique selection value
      displayUrl: opt.url,           // actual tenant url to display
      type: opt.rawType || 'user',   // "user" | "shared"
    }));
  }, [tenantOptionsv2]);



  useEffect(() => {
    return () => {
      setOnSuccesIngestLoading(false);
    };
  }, []);



  // Tenent UPdate Status
  useEffect(() => {
    if (OnSucces) {
      setOnSuccesIngestLoading(true)
    }
  }, [OnSucces]);



  useEffect(() => {
    console.log('Success state:', OnSucces);
    if (OnSucces) {
      setOnSuccesIngestLoading(true);
      setOnSuccesIngestLoading("Successful");
    } else {
      setOnSuccesIngestLoading(false);
    }
  }, [OnSucces]);


  // Tenent UPdate Status
  useEffect(() => {
    if (error) {
      Swal.fire({
        title: 'Error',
        text: error,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          onClose()
        }
      });;
    }
  }, [error]);

  useEffect(() => {
  }, [selectedFile]);

  const handleSelectChange = (selectedValue) => {
    setSelectedOption(selectedValue);

    const tenant = tenantOptionsv2.find((option) => option.value === selectedValue);

    if (tenant) {
      setSelectedTenantDetails(tenant.details);
    } else {
      setSelectedTenantDetails(null);
    }
  };

  const handleRadioChange = (event) => {
    setSelectedRadio(event.target.value);
  };

  const handleRadioChangeScenario = (event) => {
    const scenario = event.target.value;
    setSelectScenario(scenario);
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };



  const buildTenantPayload = (t) => ({
    tenantUrl: t?.tenantUrl || t?.['BHOM URL'] || '',
    itsmUrl: t?.itsmUrl || t?.['ITSM URL'] || '',
    key: t?.key || t?.['API Key'] || '',
    secretKey: t?.secretKey || t?.['Secret Key'] || '',
    username: t?.username || t?.['Username'] || '',
    password: t?.password || t?.['Password'] || '',
    type: t?.type || '',
  });



  const handleClickExecute = async (useCase, title) => {





    if (selectedTenantDetails) {
      try {
        console.log('Selected tenant details:', selectedTenantDetails);
        const tenantPayload = buildTenantPayload(selectedTenantDetails);
        await dispatch(postData(tenantPayload, useCase, title));
      } catch (error) {
        console.error('Error dispatching data:', error);
      }
    } else {
      console.log("No tenant details selected");
    }
  };





  const handleBuildYourOwn = async (selectScenario, selectedFile, narrativeTitle) => {
    if (!selectedTenantDetails) {
      alert('No tenant details selected');
      return;
    }
    if (!selectedFile) {
      alert('No file selected');
      return;
    }
    try {
      if (selectScenario === 'BHOM') {
        const tenantPayload = buildTenantPayload(selectedTenantDetails);
        await dispatch(postBYO(tenantPayload, selectedFile, 'Build Your Own (BHOM)', narrativeTitle));
      } else if (selectScenario === 'ITSM') {
        const tenantPayload = buildTenantPayload(selectedTenantDetails);
        await dispatch(postBYO(tenantPayload, selectedFile, 'Build Your Own (ITSM)', narrativeTitle));
      }

    } catch (error) {
      console.log(error);
    }
  };





  // Ingestion with service 
  const IngestWithService = async (selectedService, narrativeTitle) => {

    console.log(selectedService)

    if (!selectedTenantDetails) {
      alert('No tenant details selected');
      return;
    }
    if (!selectedService) {
      alert('Select service first');
      return;
    }

    if (narrativeTitle === 'Customer Service Management - CSM') {
      if (selectedService === 'Media Service') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'CSM Narrative (Media Service)', narrativeTitle));
        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (selectedService === 'insta-banking.com') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'CSM Narrative (Insta Banking)', narrativeTitle));
        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (selectedService === 'Apex-watches.com') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'CSM Narrative (Apex-Watches)', narrativeTitle));
        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }

    }

    console.log(`${narrativeTitle} ${selectedService}`)


    if (narrativeTitle === 'The Complete Banking Story') {
      if (selectedService === 'Application Unauthorized Change') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, `${narrativeTitle} ${selectedService}`, narrativeTitle));
        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (selectedService === 'Network Traffic Burst Impacting Applications') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, `${narrativeTitle} ${selectedService}`, narrativeTitle));
        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }



    }


    if (narrativeTitle === 'One Model, All Industries (Rename)') {
      try {
        const tenantPayload = buildTenantPayload(selectedTenantDetails);
        await dispatch(postRenameService(tenantPayload, selectedService, narrativeTitle));
      } catch (error) {
        console.error('Error dispatching rename service:', error);
      }
      return;
    }



  }


  // Ingestion with Service and Scenario
  const IngestWithServiceAndScenario = async (executionKey, narrativeTitle) => {

    console.log(executionKey)
    if (!selectedTenantDetails) {
      alert('No tenant details selected');
      return;
    }
    if (!selectedRadio) {
      alert('Select service first');
      return;
    }
    if (!selectScenario) {
      alert('Select service first');
      return;
    }

    if (narrativeTitle === 'AIOps & Observability Narrative') {

      if (executionKey === 'Media Service-Observability + Service Ops') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'Media-service-Observabilty-Service-Ops', narrativeTitle));
        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (executionKey === 'Media Service-Observability') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'Media-Service-Observabilty', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (executionKey === 'insta-banking.com-Observability + Service Ops') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'Insta-Banking-Observabilty-Service-Ops', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }

      else if (executionKey === 'insta-banking.com-Observability') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'Insta-Banking-Observabilty', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }


    }

    if (narrativeTitle === 'ServiceOps Narrative') {

      if (executionKey === 'Media Service-Full Narrative') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'ServiceOps-MS-Full', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (executionKey === 'Media Service-BHOM') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'ServiceOps-MS-BHOM', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (executionKey === 'Media Service-ITSM') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'ServiceOps-MS-ITSM', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (executionKey === 'insta-banking.com-Full Narrative') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'ServiceOps-IB-Full', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (executionKey === 'insta-banking.com-BHOM') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'ServiceOps-IB-BHOM', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }
      else if (executionKey === 'insta-banking.com-ITSM') {
        try {
          const tenantPayload = buildTenantPayload(selectedTenantDetails);
          await dispatch(postData(tenantPayload, 'ServiceOps-IB-ITSM', narrativeTitle));

        } catch (error) {
          console.error('Error dispatching data:', error);
        }
      }


    }







  }



  // Dynamically handle demoOption
  const renderOptions = () => {
    const demoOption = Narrative?.['narrative-details']?.demoOption || {};

    return Object.entries(demoOption).map(([key, value]) => {
      if (key.toLowerCase().includes('upload')) {
        return (
          <div key={key} className="file-input-container">
            <label htmlFor="csvFileInput" className="file-input-label">
              Select a CSV file:
            </label>
            <input
              type="file"
              id="csvFileInput"
              accept=".csv"
              onChange={handleFileChange}
              className="file-input"
            />
          </div>
        );
      }

      if (Array.isArray(value)) {
        return (
          <fieldset key={key}>
            <legend className='choose-an-action'>{key}</legend>
            <div className="radio-buttons-container">
              {value.map((option, index) => (
                <label key={index} className='cat-det-rad-de'>
                  <input
                    type="radio"
                    name="radioOptions"
                    className='opt-pad'
                    value={option}
                    checked={selectedRadio === option}
                    onChange={handleRadioChange}
                  />
                  <span className='span-opt'>{option}</span>
                </label>
              ))}
            </div>
          </fieldset>
        );
      }

      if (typeof value === 'object') {
        return (
          <fieldset key={key}>
            <legend className='choose-an-action'>{key}</legend>
            <div className="radio-buttons-container-byo">
              {Object.entries(value).map(([title, description], index) => (
                <label key={index} className='cat-det-rad-de'>
                  <input
                    type="radio"
                    name={`radioOptions-${key}`}
                    className='opt-pad'
                    value={title}
                    checked={selectScenario === title}
                    onChange={handleRadioChangeScenario}
                  />
                  <span className='span-opt'>
                    <strong>{title}</strong>: {description}
                  </span>
                </label>
              ))}
            </div>
          </fieldset>
        );
      }

      return null;
    });
  };






  const succesMessageClose = async () => {
    await dispatch(resetOnSuccessIngest());
    setOnSuccesIngestLoading(false);
    window.location.reload();
  };



  const SucessHandleLoadingRedirect = async () => {
    await dispatch(resetOnSuccessIngest());
    setOnSuccesIngestLoading(false);
    navigate(`${PATH.DEMO_CATALGUE_PATH}`);
  }



  useEffect(() => {
    if (tenantOptionsv2.length === 0) {
      setNoTenantsMessage('You need at least one tenant to proceed.');
    } else {
      setNoTenantsMessage('');
    }
  }, [tenantOptionsv2]);



  return (
    <>
      {loading &&
        <Loading_Scren
          LoadingAnimation={loadingAnimation}
          LoadingTitle={<span><strong>{Narrative?.['narrative-details']?.title}</strong> - Ingestion In Progress</span>}
          url={url}
          vsibilty={vsibilty}
        />
      }
      {onSuccesIngestLoading && (
        <SuccesScreen
          SuccessAnimation={SuccessAnimation}
          SucsessTitle={<span>Successfully Ingested <strong>{Narrative?.['narrative-details']?.title}</strong></span>}
          SucessHandleLoadingRedirect={SucessHandleLoadingRedirect}
          SucessHandleLoading={succesMessageClose}
        />
      )}
      <div>
        {isOpen && <div className="overlay" onClick={onClose}></div>}
        <div className={`right-side-modal ${isOpen ? 'open' : ''}`}>
          <div className="modal-content-2">
            <h1 className="close-btn" onClick={onClose}>X</h1>
            <h2 className='cat-det-cx-title'>{Narrative?.['narrative-details']?.title}</h2>
            <p className='cat-det-para'>Choose Options</p>

            {noTenantsMessage ? (
              <>
                <center><p className='tenent-warning'>{noTenantsMessage}</p></center>
                <center>
                  <button className='reset-btn-cancel-on' onClick={onClose}>Cancel</button>
                </center>
              </>
            ) : (
              <>
                <label htmlFor="selectInput" className='select-an-option'>Select a Tenant</label><br />
                <TenantDropdown
                  options={tenantDropdownOptions}
                  value={selectedOption}
                  onChange={handleSelectChange}
                  disabled={tenantDropdownOptions.length === 0}
                />

                {renderOptions()}


               
                    <div className="card-btn-sec-new-marg">
                      <button className='card-cat-btn1' onClick={() => {
                        if (!selectedTenantDetails) {
                          alert('Please select a Tenant before executing.');
                          return;
                        }

                        const narrativeTitle = Narrative?.['narrative-details']?.title;
                        const demoOption = Narrative?.['narrative-details']?.demoOption;

                        if (demoOption === null) {
                          handleClickExecute(narrativeTitle, narrativeTitle);
                        }

                        else if (selectedRadio && !selectScenario && !selectedFile) {
                          IngestWithService(selectedRadio, narrativeTitle);
                        }

                        else if (selectedRadio && selectScenario && !selectedFile) {
                          const executionKey = `${selectedRadio}-${selectScenario}`;
                          IngestWithServiceAndScenario(executionKey, narrativeTitle);
                        }

                        else if (selectScenario && selectedFile) {
                          handleBuildYourOwn(selectScenario, selectedFile, narrativeTitle);
                        }

                        else {
                          alert('Please select an option before executing.');
                        }
                      }}>Execute</button>
                      <button className='card-cat-btn2' onClick={onClose}>Cancel</button>
                    </div>
              </>
            )}


          </div>
        </div>
      </div>
    </>
  );
};










const Demo_Details_Page = (props) => {

  const { id } = useParams();
  const secretKey = 'narrative';

  const decryptId = (encryptedId) => {
    const decodedId = decodeURIComponent(encryptedId);
    const bytes = CryptoJS.AES.decrypt(decodedId, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { narrativeDetails } = useSelector(state => state.Demo_Catalgue);
  const isLoading = useSelector(state => state.Demo_Catalgue?.narrativeDetails?.isLoading);
  const errorMessage = useSelector(state => state.Demo_Catalgue?.narrativeDetails?.error);
  const errorIngest = useSelector(state => state.Ingest?.error);
  const OnSucces = useSelector(state => state.Ingest?.onSuccess);
  const loadingIngest = useSelector((state) => state.Ingest?.loading);



  const error = narrativeDetails?.data?.['error'];


  const narrativeData = narrativeDetails?.data?.['narrative-details'];
  const skipCountNarrative = narrativeDetails?.data?.['skip-count'];
  console.log(narrativeData?.fullDescription)
  const LockedTrack = narrativeDetails?.data?.['track-name'];
  const demoOption = narrativeDetails?.data?.['narrative-details']?.demoOption?.['1. Select a scenario'];

  const [selectedMedia, setSelectedMedia] = useState(null);
  const [learningHubPopup, setLearningHubPopup] = useState(false);
  const [skipPopup, setSkipPopup] = useState(false)


  const [loading, setLoading] = useState(false);
  const [fullPageloading, setFullPageLoading] = useState(true);
  const [loadingAnimation, setLoadingAnimation] = useState(LoadingBar);
  const [loadingTitle, setLoadingTitle] = useState(`Ingesting narrative In Progress`);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [url, setUrl] = useState('');
  const [vsibilty, setVsibilty] = useState('-none');
  const [hideSkipButtonModal, setHideSkipButtonModal] = useState(false);
  const [rating, setRating] = useState(2);
  const [selectedOption, setSelectedOption] = useState('');
  const [narrative, setNarrative] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [loadingDelay, setLoadingDelay] = useState(true);

  // Playbooks 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPlaybookModalOpen, setIsPlaybookModalOpen] = useState(false);
  const [selectedPlaybooks, setSelectedPlaybooks] = useState([]);
  const [selectedPlaybook, setSelectedPlaybook] = useState(null);
  const ingestionRef = useRef(null);

  useEffect(() => {
    setLearningHubPopup(false);
  }, [])
  

  useEffect(() => {
    setLearningHubPopup(false);
  }, [id]);
  

  console.log(learningHubPopup)

  useEffect(() => {
    return () => {
      // Dispatch action to clear the error when the component unmounts or modal closes
      dispatch(resetOnSuccessIngest());
    };
  }, [dispatch]);
  



  useEffect(() => {
    // Fetch narrative details
    const decryptedId = decryptId(id);
    console.log(decryptedId)
    dispatch(fetchNarrativeDetails(decryptedId));
    dispatch(resetOnSuccessIngest());
    // Set a timeout to simulate loading delay
    const timer = setTimeout(() => {
      setLoadingDelay(false);
    }, 2000);
    return () => {
      dispatch({ type: 'POST_DATA_INITAL' });
      clearTimeout(timer)
    };
  }, [dispatch, id]);


  useEffect(() => {

    if (error!== "You have not completed the track required for the narrative, please complete the micro-cert(s) required to complete the track.") {
      setLearningHubPopup(false)
    }else{
      setLearningHubPopup(true)
    }
  }, [error])

  useEffect(() => {
    if (!loadingDelay) {
      // Check if the narrative details have been loaded
      if (!isLoading && !narrativeDetails.isLoading && narrativeDetails.data) {
        const skipCount = narrativeDetails.data['skip-count'];
        console.log(skipCount);
  
        // Show the learning hub popup only if skipCount is 0
        if (skipCount === 0) {
          setLearningHubPopup(true);
        } 
      }
    }
  }, [loadingDelay, narrativeDetails]);
  








  // useEffect(() => {
  //   const foundNarrative = narratives.find(narrative => narrative.id === id);
  //   if (foundNarrative) {
  //     setNarrative(foundNarrative);
  //   } else {
  //     console.error(`Narrative with id '${id}' not found`);
  //   }
  // }, [id]);



  useEffect(() => {
    if (narrative) {
      setLoadingTitle(<>Ingesting <span className='resent-name'>{narrative.name}</span> In Progress</>);
    }
  }, [narrative]);



  useEffect(() => {
    setFullPageLoading(true)
    setTimeout(() => {
      setFullPageLoading(false)
    }, 3000);
  }, [])


  // Demo Details
  useEffect(() => {
    if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessage]);









  const handleShowSkipPopup = () => setSkipPopup(true);
  const handleCloseSkipPopup = () => setSkipPopup(false);

  const handleShowLearningHubPopup = () => setLearningHubPopup(true);
  const handleCloseLearningHubPopup = () => setLearningHubPopup(false);
  const handleShowDemoOptionPopup = () => setShowModal(true);
  const handleCloseDemoOptionPopup = () => setShowModal(false);


  const handlePlaybookClick = (playbook) => {
    if (Array.isArray(playbook) && playbook.length > 1) {
      setSelectedPlaybooks(playbook);
      setIsModalOpen(true);
    } else if (Array.isArray(playbook) && playbook.length === 1) {
      const url = `${PATH.DEMO_CATALGUE_DETAILS_PLAYBOOK_PATH}${playbook[0].releaseDate}`;
  
      // Store the first playbook in sessionStorage
      localStorage.setItem('playbookData', JSON.stringify(playbook[0]));
  
      // Open new tab
      window.open(url, '_blank');
    } else if (playbook && !Array.isArray(playbook)) {
      const url = `${PATH.DEMO_CATALGUE_DETAILS_PLAYBOOK_PATH}${playbook.releaseDate}`;
  
      // Store playbook data in sessionStorage
      localStorage.setItem('playbookData', JSON.stringify(playbook));
  
      // Open new tab
      window.open(url, '_blank');
    }
  };
  


  const handlePlaybookSelection = (playbook) => {
    const url = `${PATH.DEMO_CATALGUE_DETAILS_PLAYBOOK_PATH}${playbook.releaseDate}`; // Adjusted to use releaseDate for URL
    
    // Store playbook data directly in sessionStorage
    localStorage.setItem('playbookData', JSON.stringify(playbook));
  
    // Open new tab
    window.open(url, '_blank');
  };
  

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPlaybook(null);
    setSelectedPlaybooks([]);
  };

  const closePlaybookModal = () => {
    setIsPlaybookModalOpen(false);
    setSelectedPlaybook(null);
  };


  const toggleModal = () => {
    // Check if the track is completed
    //const isTrackCompleted = checkCompletionStatus();
    const isTrackCompleted = true

    if (isTrackCompleted) {

      // If track is not completed, show the learning hub popup
      setModalOpen(!modalOpen);

    } else {

      setLearningHubPopup(true);

    }


  };









  // Handler for select input change
  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };



  const handleClick = (value) => {
    setRating(value);
  };



  // Function to handle skip button click in the modal
  const handleSkipButtonClickModal = () => {
    const skipCount = parseInt(localStorage.getItem('modalSkipCount')) || 0;
    localStorage.setItem('modalSkipCount', skipCount + 1);
    if (skipCount + 1 >= 3) {
      // Hide the skip button if count exceeds 3
      setHideSkipButtonModal(true);
    }
    handleCloseLearningHubPopup();
  };







  // Sample video data
  const videos2 = [
    { src: 'https://www.example.com/video1.mp4', type: 'video/mp4' },
    { src: 'https://www.example.com/video2.mp4', type: 'video/mp4' },
    { src: 'https://www.example.com/video2.mp4', type: 'video/mp4' },
    // Add more video objects as needed
  ];





  const media = narrativeDetails.data?.['narrative-details']?.content;




  const handleMediaClick = (media) => {
    setSelectedMedia(media);
  };

  const closeLightbox = () => {
    setSelectedMedia(null);
  };



  // Ref for Ingestion Block


  // Function to scroll to Ingestion Block
  const scrollToIngestion = () => {
    if (ingestionRef.current) {
      ingestionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };





  const handleClickExecute = (selectedTenantDetails) => {
    setLoading(true);
    setVsibilty('-none');
    // If track is completed, proceed with loading animation and execution
    const timer = setTimeout(() => {
      setLoadingAnimation(SuccessBar);
      setLoadingTitle(<>Successfully Ingested <span className='resent-name'>{narrative && narrative.name}</span></>);
      setShowSuccessMessage(true);
      setVsibilty('-show');
      setUrl(`${PATH.DEMO_CATALGUE_PATH}`);
    }, 10000);
    return () => clearTimeout(timer);
  };




  function copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Password copied to clipboard!');
    }).catch(err => {
      toast.error('Failed to copy Password.');
    });
  }

  const handlecloseloading = () => {
    setLoading(false);
    setLoadingAnimation(LoadingBar); // Reset to initial value
    setLoadingTitle(`Ingesting ${narrative.name} In Progress`)
    toggleModal()
  }






  const handleExecuteOne = () => {
    if (skipCountNarrative === undefined) {
      togglefunction()
    } else if (skipCountNarrative > 0 && skipCountNarrative <= 3) {
      handleShowSkipPopup();
    }
  }


  const togglefunction = () => {
    handleCloseSkipPopup();
    toggleModal()
  }




  return (
    <>
      {isLoading && <LoadingScreen text={`Loading...`} />}

      {/* {fullPageloading &&
        <Loading_Scren_gif
          LoadingAnimation={DCLOGOLOAD}
          LoadingTitle="fjkfd" />} */}

      <BackNavbar />



      <div>

        <section className='demo-details-page-background'>
          <div className='container'>
            <br></br>
            <p className='bredcrumb-demo'>Home / Demo Catalogue /  {narrativeData && narrativeData?.title} </p>
            <div class="centered-div">
              <div class="small-square"></div>
              <div className='centred-dive-col'>
                <div class="row">
                  {!isLoading && narrativeData &&  (
                    <div class="col-md-6 order-md-2">
                      <center>
                        <MainImage imageUrl={narrativeData?.thumbnail} />
                        <Carousel media={media} onMediaClick={handleMediaClick} />
                        {selectedMedia && (
                          <center>
                          <Lightbox media={selectedMedia} onClose={closeLightbox} />
                          </center>
                        )}
                      </center>
                    </div>
                  )}

                  <div class="col-md-6 order-md-1">
                    {/* {narrativeData && narrativeData.playbook && ( */}
                    {!isLoading && narrativeData && (
                      <>
                        <h2 className='cat-det-cx-title'>{narrativeData && narrativeData?.title}</h2>
                        <div class="line"></div>
                        <div className='nar-det-page'>
                        <div dangerouslySetInnerHTML={{ __html: narrativeData?.fullDescription }} />
                        </div>
                        <br></br>
                        <div className="card-cat-buttons-container">
                          <button class="card-cat-btn1" onClick={handleExecuteOne}>Execute</button>
                          {narrativeData?.playbook ? (
                            <><button class="card-cat-btn2" onClick={() => handlePlaybookClick(narrativeData?.playbook)}>Playbook</button></>
                          ) : (
                            <></>
                          )}
                        </div>
                      </>
                    )}
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br></br>
          <br></br>
          <br></br>
        </section>

       

      </div>

      {/* Lock Narartives */}
      <Modal
        {...props}
        size="mg"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        // onHide={handleCloseLearningHubPopup}
        show={learningHubPopup} fullscreen={false} >
        <Modal.Body className='modalght'>
          <div className="container">
            <div className='modal-div-2'>
              <img src={learninghublogo} alt="Full Size Image" className="img-fluid" style={{ width: '30%', marginTop: '20px' }} />
              <h1 className='learning-war-h1'>Unlock This Narrative!</h1>
              <div class="popup-body">
                {narrativeDetails && (
                  <p className='popup-body-para'>
                    You need to complete all micro-certs under <br></br><strong className='popup-body-para-storng'>{LockedTrack}</strong> track to run this narrative.
                  </p>
                )}
                <p className='popup-body-para'>
                  Enhance your knowledge and skills to unlock this exciting content and gain more insights!
                </p>
              </div>
              <div className='lear-hub-warning-btn'>
                {narrativeDetails && (
                  <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${LockedTrack}`}><button className='lear-go-to-lear'>Go to {LockedTrack} Track</button></Link>
                )}

                {/* {skipCountNarrative !== null && skipCountNarrative !== undefined && (
                  <p className="lear-skip">
                    Skip Count <span className="skip-count">{skipCountNarrative}</span>
                  </p>
                )} */}





               
                  {skipCountNarrative !== null && skipCountNarrative !== undefined ? (
                    <>
                      <p className="lear-skip">
                    Skip Count <span className="skip-count">{skipCountNarrative}</span>
                  </p>
                    </>
                  ) : (
                    <Link to={`${PATH.DEMO_CATALGUE_PATH}`} style={{ textDecoration: 'none',color:'#000'}}>
                    <p className='back-to-demo'>Go to Demo Catalogue</p>
                    </Link>
                  )}
              

              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>




      {/* Skip Popup */}
      <Modal
        {...props}
        size="mg"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        // onHide={handleCloseLearningHubPopup}
        show={skipPopup} fullscreen={false} >
        <Modal.Body className='modalght'>
          <div className="container">
            <div className='modal-div-2'>
              <img src={learninghublogo} alt="Full Size Image" className="img-fluid" style={{ width: '30%', marginTop: '20px' }} />
              <h1 className='learning-war-h1'>Unlock This Narrative!</h1>
              <div class="popup-body">
                {narrativeDetails && (
                  <p className='popup-body-para'>
                    To access the <strong className='popup-body-para-storng'>{narrativeData?.title}</strong>, you need to complete the
                    <strong className='popup-body-para-storng-orange'> {narrativeData?.track}</strong> track along with all related micro-certifications.
                  </p>
                )}
                <p className='popup-body-para'>
                  Enhance your knowledge and skills to unlock this exciting content and gain more insights!
                </p>
              </div>
              <div className='lear-hub-warning-btn'>
                <button className='lear-go-to-lear' onClick={togglefunction}>Skip for Now</button>
                <p className='lear-skip'>Skip Count   <span className='skip-count'>{skipCountNarrative}</span></p>
              </div>
            </div>


          </div>
        </Modal.Body>
      </Modal>



      {/* Modal for selecting playbooks if there are multiple */}
      <Modal show={isModalOpen} onHide={closeModal} centered>
        <Modal.Body>
          <button className="close-button-black" onClick={() => closeModal()}><span aria-hidden="true">&times;</span></button><br></br>
          <div class="row">
            {selectedPlaybooks.map((playbook, index) => (
              <div class="col" key={index}>
                <div className="bg-primary-playbook-demo-catal" onClick={() => handlePlaybookSelection(playbook)}>
                  {playbook.title}
                </div>

              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>






      {/* Modal for displaying selected playbook */}
      <Modal
        {...props}
        size="xl"
        show={isPlaybookModalOpen}
        onHide={closePlaybookModal}
        centered>

        <Modal.Body className='content-store-popup'>
          <div className="container">
            <div className='modal-div-learning'>
              <div className="row">
                <div className="col-sm-8 mb-3 mb-sm-0">
                  {selectedPlaybook && (
                    <div className="file-container">
                      <iframe src={normalizeMediaUrl(selectedPlaybook.viewUrl, 'preview')} frameborder="0" width="100%" height="100%" allowfullscreen="true" title="File Preview"></iframe>
                    </div>
                  )}
                </div>
                <div className="col-sm-4 mb-3 mb-sm-0">
                  <div className="file-controls-dive">
                    <h1 className='file-tite-des'>{selectedPlaybook && selectedPlaybook.title}</h1>
                    <div class="line"></div>
                    <p className='file-p-des'>Publish Date : {selectedPlaybook && selectedPlaybook.releaseDate}</p>
                    <p className='file-p-des'>Password :
                      <span
                        onClick={() => copyToClipboard('Playbook@123')}
                        style={{ cursor: 'pointer', }}
                        className='passowrd'>
                        Copy Password
                      </span>
                    </p>
                    <button className='card-cat-cancel' onClick={closePlaybookModal}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>



      <ToastContainer position="bottom-center" autoClose={4000} hideProgressBar={false} />

      <RightSideModal
        isOpen={modalOpen}
        onClose={toggleModal}
        Narrative={narrativeDetails?.data}
      />




    </>
  );
};



export default Demo_Details_Page;
